import { render, staticRenderFns } from "./ItemSeparator.vue?vue&type=template&id=036e9a5b&scoped=true&"
import script from "./ItemSeparator.vue?vue&type=script&lang=js&"
export * from "./ItemSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e9a5b",
  null
  
)

export default component.exports